
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_49136","data-name":"Group 49136","transform":"translate(-573.5 17)"}},[_c('path',{attrs:{"id":"Path_37644","data-name":"Path 37644","d":"M4 0h8a4 4 0 014 4v8a4 4 0 01-4 4H4a4 4 0 01-4-4V4a4 4 0 014-4z","transform":"translate(573.5 -17)","fill":"#5858ec"}}),_c('g',{attrs:{"id":"Group_47853","data-name":"Group 47853","transform":"translate(578.75 -12.5)"}},[_c('g',{attrs:{"id":"Group_47854","data-name":"Group 47854","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}},[_c('path',{attrs:{"id":"Path_37642","data-name":"Path 37642","d":"M1 3.5L3.5 1 6 3.5M3.5 7V1","transform":"translate(-.5 -.5)"}}),_c('path',{attrs:{"id":"Path_37643","data-name":"Path 37643","d":"M1 3.5L3.5 1 6 3.5M3.5 7V1","transform":"translate(-.5 -.5)"}})])])])])
          )
        }
      }
    